import {
    getMessageId
} from '@/utils/chat/messageUtils';

export default {
    data() {
        return {
            multipleMessageArr: [],
            multiMessageOptionEnabled: false,
            forwardMsgPopup: false,

            deleteMessageDataObj: {
                id: '',
                text: '',
                time: '',
                createdBy: '',
                roomId: ''
            },
            deleteMsgPopupState: false,

            
            replyMessageFullPreviewData:null,
            replyMessageFullPreviewState: false,
        };
    },

    methods: {
        replyMessageFullPreviewMethod(message) {
            this.replyMessageFullPreviewData = message;
            this.replyMessageFullPreviewState = true;
            document.body.classList.add(
                'body_right_scroll_remove'
            );
        },
        
        getMessageId(message) {
            return getMessageId(message);
        },

        toggleSelectedMessage(message) {
            const messageId =
                this.getMessageId(message);

            if (
                messageId === null ||
                messageId === undefined
            ) {
                return;
            }

            const messageIndex =
                this.multipleMessageArr.findIndex(
                    (item) => {
                        return (
                            String(
                                this.getMessageId(item)
                            ) ===
                            String(messageId)
                        );
                    }
                );

            if (messageIndex !== -1) {
                this.multipleMessageArr.splice(
                    messageIndex,
                    1
                );
            } else {
                this.multipleMessageArr.push(message);
            }

            this.multiMessageOptionEnabled =
                this.multipleMessageArr.length > 0;
        },

        forwardMsgToUserMethod(message) {
            const messageId =
                this.getMessageId(message);

            if (
                messageId === null ||
                messageId === undefined
            ) {
                return;
            }

            const alreadySelected =
                this.multipleMessageArr.some((item) => {
                    return (
                        String(
                            this.getMessageId(item)
                        ) ===
                        String(messageId)
                    );
                });

            if (!alreadySelected) {
                this.multipleMessageArr.push(message);
            }

            this.multiMessageOptionEnabled = true;
            this.messageContentDraftValue = '';
            this.cancelReplyMessageOnChatMethod(false);
            this.$nextTick(this.resetAutoResizeMethod);
        },

        clearMultipleMsgDataMethod() {
            this.multiMessageOptionEnabled = false;
            this.multipleMessageArr = [];
        },

        forwardMultipleMsgToUserMethod() {
            if (this.multipleMessageArr.length) {
                this.forwardMsgPopup = true;
            }
        },

        handleForwardPopupState(state) {
            this.forwardMsgPopup = Boolean(state);

            if (!state) {
                this.clearMultipleMsgDataMethod();
            }
        },

        handleForwardedMessages(payload) {
            if (
                !payload ||
                !payload.destinationRoom
            ) {
                return;
            }

            this.clearMultipleMsgDataMethod();

            this.$emit(
                'forward-room-change',
                payload.destinationRoom
            );
        },

        handleDeleteMessage(message) {
            const data =
                message && message.chat_data
                    ? message.chat_data
                    : message;

            if (!data) {
                return;
            }

            const sender = data.sender || {};
            const messageId =
                data.id !== undefined
                    ? data.id
                    : data.message_id;

            this.deleteMessageFromChatMethod(
                messageId,
                data.message || data.text || '',
                data.timestamp || data.time || '',
                sender.user_id !== undefined
                    ? sender.user_id
                    : data.createdBy
            );
        },

        deleteMessageFromChatMethod(
            messageId,
            messageText,
            messageTime,
            createdBy
        ) {
            if (
                messageId === undefined ||
                messageId === null ||
                !this.selectedRoomInfo
            ) {
                return;
            }

            this.deleteMessageDataObj = {
                id: messageId,
                text: messageText,
                time: messageTime,
                createdBy,
                roomId:
                    this.selectedRoomInfo.chat_room
            };

            this.deleteMsgPopupState = true;
        },

        // Keep the existing misspelled public method for old templates.
        deteteMessageFromChatMethod(
            messageId,
            messageText,
            messageTime,
            createdBy
        ) {
            return this.deleteMessageFromChatMethod(
                messageId,
                messageText,
                messageTime,
                createdBy
            );
        }
    }
};
